export default {
  type: "object",
  properties: {
    recommended_size_index: {
      type: "integer",
      description: "index of recommended size",
      example: 0
    },
    sizes: {
      type: "array",
      items: { $ref: "#/components/schemas/sizeAdvisorSize" },
      description: "How well size fits"
    }
  }
};
